export enum EquipmentStatusEnum {
    Active = 1,
    Inactive = 2,
    UnderMaintenance = 3,
    Retired = 4,
    Lost = 5,
}
